import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, ref, watch } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreator',
    props: {
        oncancel: null,
        hideSourceItems: { type: Boolean },
        suggestedName: { default: "" },
        renderExtensionsToggle: { type: Boolean }
    },
    emits: ["remove-extensions-toggle", "clicked-create", "onUpdateHideSourceItems"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faChevronDown, faChevronUp);
        const isExpanded = ref(false);
        const collectionName = ref(props.suggestedName);
        const localHideSourceItems = ref(props.hideSourceItems);
        const validInput = computed(() => {
            return collectionName.value.length > 0;
        });
        function clickForHelp() {
            isExpanded.value = !isExpanded.value;
            return isExpanded.value;
        }
        function cancelCreate() {
            props.oncancel();
        }
        watch(() => localHideSourceItems.value, () => {
            emit("onUpdateHideSourceItems", localHideSourceItems.value);
        });
        return { __sfc: true, props, emit, isExpanded, collectionName, localHideSourceItems, validInput, clickForHelp, cancelCreate, faChevronDown, faChevronUp, FontAwesomeIcon, localize };
    }
});
